import React from "react";
import CheckIcon from "./CheckIcon";
import { IconMapPinCheck } from "@tabler/icons-react";

const ResultsTable = ({ results, onSelectAlternative }) => {
  const hasAlternatives = results.some((row) => row.origin?.alternatives?.length > 0 || row.destination?.alternatives?.length > 0);

  return (
    <div className="card mt-3">
      <div className="card-body">
        <table className="table table-striped my-3">
          <thead>
            <tr>
              <th>Grupo</th>
              <th>Tipo de Vale</th>
              <th>Fecha Solicitud</th>
              <th>Tipo de móvil</th>
              <th>Móvil</th>
              <th>Total Servicio</th>
              <th>Pasajero</th>
              <th className="col-background">Origen</th>
              <th>Destino</th>
              <th>Hora Ini.</th>
              <th>Hora Térm.</th>
              {hasAlternatives ? (
                <>
                  <th>Alternativas Origen</th>
                  <th>Alternativas Destino</th>
                </>
              ) : (
                <th>Estado</th>
              )}
            </tr>
          </thead>
          <tbody>
            {results.map((row, index) => (
              <tr key={index}>
                <td>{row.Grupo}</td>
                <td>{row.TipoVale}</td>
                <td>{row.Fecha}</td>
                <td>{row.TipoMovil}</td>
                <td>{row.NMovil}</td>
                <td>{row.TotalServicio}</td>
                <td>{row.Pasajero}</td>
                <td>{row.Origen}</td>
                <td>{row.Destino}</td>
                <td>{row.HoraInicio}</td>
                <td>{row.HoraTermino}</td>
                {hasAlternatives ? (
                  <>
                    <td>
                      {row.origin?.alternatives?.length > 0 ? (
                        <ul>
                          {row.origin.alternatives.map((alt, i) => (
                            <li key={i}>
                              {alt.address}
                              <button className="btn btn-sm btn-primary ms-2" onClick={() => onSelectAlternative(alt.placeID, index, false)}>
                                Seleccionar
                              </button>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <div className="text-center">
                          <IconMapPinCheck size={30} className="text-primary" />
                        </div>
                      )}
                    </td>
                    <td>
                      {row.destination?.alternatives?.length > 0 ? (
                        <ul>
                          {row.destination.alternatives.map((alt, i) => (
                            <li key={i}>
                              {alt.address}
                              <button className="btn btn-sm btn-primary ms-2" onClick={() => onSelectAlternative(alt.placeID, index, true)}>
                                Seleccionar
                              </button>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <div className="text-center">
                          <IconMapPinCheck size={30} className="text-primary" />
                        </div>
                      )}
                    </td>
                  </>
                ) : (
                  <td className="text-center">
                    <CheckIcon />
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ResultsTable;
